import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ArrayTotalizarByProp } from "../../Actions/TotalizarProps";
import { GetKey, GetPeriodo } from "../../Actions/GetContainer";
import request from "../../../../Helpers/API";
import { GetMonthNameByNumber } from "../../Helper/GetMonthNameByNumber";
// import { useBox } from '../../Helper/useBox';
import { useBoxProyecciones } from "../ProyeccionesVentas/useBoxProyecciones";
// import { BoxStructure } from './BoxSctructure';
import { BoxStructure } from "../ProyeccionesVentas/BoxStructure";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { LoaderScreen } from "../../../components/LoaderScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

export const ProyeccionGastoScreen = () => {
  const [boxstate, setBoxState, updateBoxState] = useBoxProyecciones();
  const history = useHistory();
  const location = useLocation();
  const onHome = () => {
    history.push("/Finanzas/Main");
  };
  const [primeraVez, setPrimeraVez] = useState(true);
  const sucursales = location.state?.sucursales;

  const idSucursalUnicos = [
    ...new Map(
      sucursales === undefined || sucursales === null || sucursales.length === 0
        ? []
        : sucursales.map((item) => [
            item.idsucursal,
            { idsucursal: item.idsucursal },
          ]),
    ).values(),
  ];
  
  const [titulo, setTitulo] = useState({
    periodoinicio: "0",
    periodofin: "0",
    ejercicioinicio: "0",
    ejerciciofin: "0",
    comparacion: "R",
  });

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [state, setState] = useState({
    data: [],
  });
  useEffect(() => {
    BoxClick();
  }, []);

  useEffect(() => {
    setPrimeraVez(false);
  }, []);

  // console.log(boxstate)
  const BoxClick = () => {
    setLoader({ ...loader, mostrar: true });
    return new Promise((res, req) => {
      const post = {
        ejercicio: Number(boxstate.ejercicioinicio),
        ejercicioant: Number(boxstate.ejerciciofin),
        comparar: boxstate.comparacion,
        Periodo: GetPeriodo(boxstate.periodoinicio, boxstate.periodofin),
        departamento: GetKey(boxstate.pv.departamento, ["iddepartamento"]),
        sucursal:
          primeraVez ||
          boxstate?.pv?.sucursal === "" ||
          boxstate?.pv?.sucursal === 0 ||
          boxstate?.pv?.sucursal === "0" ||
          boxstate?.pv?.sucursal === undefined ||
          (Array.isArray(boxstate?.pv?.sucursal) &&
            boxstate.pv.sucursal.length === 0)
            ? GetKey(idSucursalUnicos, ["idsucursal"])
            : GetKey(boxstate.pv.sucursal, ["idsucursal"]),
        adr: GetKey(boxstate.pv.adr, ["idadr"]),
      };
      request
        .post("ProyeccionesGastos/Obtener", post)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setTitulo({
            ...titulo,
            periodoinicio: boxstate.periodoinicio,
            periodofin: boxstate.periodofin,
            ejercicioinicio: boxstate.ejercicioinicio,
            ejerciciofin: boxstate.ejerciciofin,
            comparacion: boxstate.comparacion === "R" ? "REAL" : "PROYECTADO",
          });
          setState({
            ...state,
            data: result,
          });
          res("");
        })
        .catch((err) => {
          // req(JSON.stringify(err))
          console.log(err);
        });
      setLoader({ ...loader, mostrar: true });
    });
  };
  const imprimirexcelgrupo = () => {
    setLoader({ ...loader, mostrar: true });
    if (boxstate.ejercicio == "0") {
      // changeloading("Favor de indicar el ejercicio", true)
      return;
    }
    request
      .get(
        `ProyeccionesGastos/PGConsolidadoExcel?ejercicio=${boxstate.ejercicioinicio}`,
      )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((err) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PROYECCION DE GASTOS", JSON.stringify(err), "error");
      });
  };

  const imprimirexcel = () => {
    // stratloading(true);
    if (titulo.ejercicio == "0") {
      // changeloading("Favor de indicar el ejercicio", true)
      return;
    }
    if (titulo.mesinicio == "0") {
      // changeloading('Favor de indicar el mes de inicio', true)
      return;
    }
    if (titulo.mesfin == "0") {
      // changeloading('Favor de indicar el mes fin', true)
      return;
    }
    const post = {
      ejercicio: Number(boxstate.ejercicio),
      Periodo: GetPeriodo(boxstate.mesInicio, boxstate.mesFin),
      departamento: GetKey(boxstate.pv.departamento, ["iddepartamento"]),
      sucursal: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
      adr: GetKey(boxstate.pv.adr, ["idadr"]),
      subtitulo: SubTitulo(),
      region: boxstate.titulosucursal,
      subdepartamento: boxstate.titulodepartamento,
    };
    request
      .post("RevisionProyeccion/RevisionProyeccionGastosExcel", post)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        // stratloading(false);
      })
      .catch((err) => {
        // changeloading(JSON.stringify(err), false)
      });
  };
  const SubTitulo = () => {
    if (titulo.ejercicioinicio === "0") return "";
    else {
      if (
        Number(titulo.periodoinicio) === Number(titulo.periodofin) &&
        Number(titulo.ejercicioinicio) === Number(titulo.ejerciciofin)
      ) {
        return `${GetMonthNameByNumber(
          titulo.periodoinicio,
        ).toUpperCase()} DEL ${titulo.ejercicioinicio}`;
      } else if (
        Number(titulo.periodoinicio) !== Number(titulo.periodofin) &&
        Number(titulo.ejercicioinicio) === Number(titulo.ejerciciofin)
      ) {
        return `DE ${GetMonthNameByNumber(
          titulo.periodoinicio,
        ).toUpperCase()} A ${GetMonthNameByNumber(
          titulo.periodofin,
        ).toUpperCase()} DEL ${titulo.ejercicioinicio}`;
      } else if (
        Number(titulo.periodoinicio) === Number(titulo.periodofin) &&
        Number(titulo.ejercicioinicio) !== Number(titulo.ejerciciofin)
      ) {
        return `${GetMonthNameByNumber(
          titulo.periodoinicio,
        ).toUpperCase()} DEL ${titulo.ejercicioinicio} CONTRA ${
          titulo.ejerciciofin
        }`;
      } else {
        return `DE ${GetMonthNameByNumber(
          titulo.periodoinicio,
        ).toUpperCase()} A ${GetMonthNameByNumber(
          titulo.periodofin,
        ).toUpperCase()} DEL ${titulo.ejercicioinicio} CONTRA  ${
          titulo.ejerciciofin
        }`;
      }
    }
  };
  return (
    <PlantillaScreen
      titulo={`PROYECCIONES DE GASTOS ${SubTitulo()}`}
      className={"proyecciones-gastos-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="proyecciones-gastos-contenedor-filtros">
        <div className="proyecciones-gastos-regresar" onClick={() => onHome()}>
          <ArrowBackIcon /> Regresar
        </div>
        <BoxStructure
          onBoxChange={setBoxState}
          boxState={boxstate}
          BoxClick={BoxClick}
          updateBoxState={updateBoxState}
          titulo_filtro={"FILTRO ESTADO DE PROYECCION DE GASTOS"}
          // titulo='Estado de Resultados Comparativo real vs proyeccion'
          // subtitulo={SubTitulo()}
          extrayear={3}
          sucursales={sucursales}
        >
          <div
            className="pg-actions"
            key={"box-actions"}
            onClick={() => imprimirexcelgrupo()}
          >
            Desargar Excel
          </div>
        </BoxStructure>
      </div>
      <div
        id="comparativa-gastos-proyeccion-tipo"
        className="scroll-4"
        style={{ marginTop: 10 }}
      >
        {state.data === undefined ||
        state.data === null ||
        state.length === 0 ? (
          <div>No existen datos para mostrar </div>
        ) : (
          <table
            className="table-informacion-gastos"
            cellSpacing={0}
            style={{ marginTop: 10 }}
            id="tabla-sticky"
          >
            <thead>
              <tr className="tr-encabezado1">
                <th className="w-cuenta sticky-col-h-30">CUENTA</th>
                <th className="w-concepto sticky-col-h-30">
                  <div>CONCEPTO</div>
                </th>
                <th className="w-importe sticky-col-h-30">
                  <div>{`PROYECCION ${titulo.ejercicioinicio}`}</div>
                </th>
                <th className="w-importe sticky-col-h-30">
                  <div>{`${titulo.comparacion} ${titulo.ejerciciofin}`}</div>
                </th>
                <th className="w-importe sticky-col-h-30">
                  <div>DIFERENCIA</div>
                </th>
                <th className="w-importe sticky-col-h-30">%</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  letterSpacing: 1,
                  textAlign: "center",
                }}
              >
                <td className="bl br" colSpan={6}>
                  Gastos Variables
                </td>
              </tr>
              {state.data
                .filter((x) => x.tipo === "V")
                .map((item) => (
                  <tr>
                    <td className="bl">{item.cuenta}</td>
                    <td>{item.concepto}</td>
                    <td className="ta-right bl">{FormatMoney(item.proy)}</td>
                    <td className="ta-right pr-5 ">
                      {FormatMoney(item.total)}
                    </td>
                    <td className="ta-right bl">
                      {FormatMoney(item.diferencia)}
                    </td>
                    <td className="ta-right br pr-5 ">
                      {FormatMoney(item.por)} %
                    </td>
                  </tr>
                ))}
              <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                <td
                  colSpan={2}
                  style={{
                    fontWeight: "bold",
                    textAlign: "right",
                    paddingRight: 10,
                  }}
                  className="bl"
                >
                  Total Gastos Variables
                </td>
                <td className="ta-right">
                  {FormatMoney(
                    ArrayTotalizarByProp(
                      state.data.filter((x) => x.tipo === "V"),
                      "proy",
                    ),
                  )}
                </td>
                <td className="ta-right">
                  {FormatMoney(
                    ArrayTotalizarByProp(
                      state.data.filter((x) => x.tipo === "V"),
                      "total",
                    ),
                  )}
                </td>
                <td className="ta-right">
                  {FormatMoney(
                    ArrayTotalizarByProp(
                      state.data.filter((x) => x.tipo === "V"),
                      "diferencia",
                    ),
                  )}
                </td>
                <td className="ta-right">
                  {FormatMoney(
                    (ArrayTotalizarByProp(
                      state.data.filter((x) => x.tipo === "V"),
                      "diferencia",
                    ) /
                      ArrayTotalizarByProp(
                        state.data.filter((x) => x.tipo === "V"),
                        "total",
                      )) *
                      100,
                  )}{" "}
                  %
                </td>
              </tr>
              <tr>
                <td colSpan={6}></td>
              </tr>

              <tr
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  letterSpacing: 1,
                  textAlign: "center",
                }}
              >
                <td className="bl br" colSpan={6}>
                  Gastos Fijos
                </td>
              </tr>
              {state.data
                .filter((x) => x.tipo === "F")
                .map((item) => (
                  <tr>
                    <td className="bl">{item.cuenta}</td>
                    <td>{item.concepto}</td>
                    <td className="ta-right bl">{FormatMoney(item.proy)}</td>
                    <td className="ta-right pr-5 ">
                      {FormatMoney(item.total)}
                    </td>
                    <td className="ta-right bl">
                      {FormatMoney(item.diferencia)}
                    </td>
                    <td className="ta-right br pr-5 ">
                      {FormatMoney(item.por)} %
                    </td>
                  </tr>
                ))}
              <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                <td
                  colSpan={2}
                  style={{
                    fontWeight: "bold",
                    textAlign: "right",
                    paddingRight: 10,
                  }}
                  className="bl"
                >
                  Total Gastos Fijos
                </td>
                <td className="ta-right">
                  {FormatMoney(
                    ArrayTotalizarByProp(
                      state.data.filter((x) => x.tipo === "F"),
                      "proy",
                    ),
                  )}
                </td>
                <td className="ta-right">
                  {FormatMoney(
                    ArrayTotalizarByProp(
                      state.data.filter((x) => x.tipo === "F"),
                      "total",
                    ),
                  )}
                </td>
                <td className="ta-right">
                  {FormatMoney(
                    ArrayTotalizarByProp(
                      state.data.filter((x) => x.tipo === "F"),
                      "diferencia",
                    ),
                  )}
                </td>
                <td className="ta-right pr-5">
                  {FormatMoney(
                    (ArrayTotalizarByProp(
                      state.data.filter((x) => x.tipo === "F"),
                      "diferencia",
                    ) /
                      ArrayTotalizarByProp(
                        state.data.filter((x) => x.tipo === "F"),
                        "total",
                      )) *
                      100,
                  )}{" "}
                  %
                </td>
              </tr>
              <tr>
                <td colSpan={6}></td>
              </tr>
              <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                <td
                  colSpan={2}
                  style={{
                    fontWeight: "bold",
                    textAlign: "right",
                    paddingRight: 10,
                  }}
                  className="bl"
                >
                  Total
                </td>
                <td className="ta-right">
                  {FormatMoney(ArrayTotalizarByProp(state.data, "proy"))}
                </td>
                <td className="ta-right">
                  {FormatMoney(ArrayTotalizarByProp(state.data, "total"))}
                </td>
                <td className="ta-right">
                  {FormatMoney(ArrayTotalizarByProp(state.data, "diferencia"))}
                </td>
                <td className="ta-right pr-5">
                  {FormatMoney(
                    (ArrayTotalizarByProp(state.data, "diferencia") /
                      ArrayTotalizarByProp(state.data, "total")) *
                      100,
                  )}{" "}
                  %
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </PlantillaScreen>
  );
};
